import * as types from 'mutation-types'
import model from 'api'
const state = {
  list: [],
  total: 0,
  loadingList: false
}

const getters = {
  productList (state) {
    return state.list
  }
}

const mutations = {
  [types.PRODUCTS_SET_LIST] (state, { list, total }) {
    state.list = list
    state.total = total
  },
  [types.PRODUCTS_SET_LIST_LOADING] (state, loading) {
    state.loadingList = loading
  }
}

const actions = {
  async getList ({ commit, state }) {
    try {
      commit(types.PRODUCTS_SET_LIST_LOADING, true)
      const { list, total } = await model.Products.getList(state.condition)
      commit(types.PRODUCTS_SET_LIST, { list, total })
    } catch (e) {
      commit(types.PRODUCTS_SET_LIST, { list: [], total: 0 })
    } finally {
      commit(types.PRODUCTS_SET_LIST_LOADING, false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
